// extracted by mini-css-extract-plugin
export var container = "_my-0";
export var dotAnimation = "_my-2";
export var dotsLoading = "_my-1";